<template>
    <div>
        <b-sidebar id="sidebar-backdrop" class="sidebar-task" :backdrop-variant="'dark'" :title="taskTitle" backdrop shadow
            :visible="showRecord" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addUpdateTask.basic') }}</h3>
                    <b-col md="6" sm="12">
                        <div class="text-left mt-3">
                            <label for="modal-add-record-date-datepicker" class="state">{{ $t('addUpdateTask.dueDateLabel') }}</label>
                            <date-picker v-model="recordPayload.due_date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="recordPayload.due_date = ''" :placeholder="$t('addUpdateTask.selectDueDate')"
                                class="date-picker-custom" :teleport="'body'"></date-picker>
                            <p v-if="errors && errors.due_date" class="field-error">
                                {{ errors.due_date[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col md="6" sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addUpdateTask.assignedToLabel') }}</label>
                        <v-select class="bg_white w-100 f-12" v-model="recordPayload.assigned_to" :options="nameOptions"
                            item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers">
                            <span slot="no-options">
                                {{ $t('addUpdateTask.searchUser') }}
                            </span>
                        </v-select>
                        <p v-if="errors && errors.assigned_to" class="field-error">
                            {{ errors.assigned_to[0] }}
                        </p>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <b-form-group :label="$t('addUpdateTask.titleLabel')" label-for="check-user" class="text-left">
                            <b-form-input type="text" :placeholder="$t('addUpdateTask.titlePlaceholder')" class="input f-12" required
                                v-model="recordPayload.title"></b-form-input>
                            <p v-if="errors && errors.title" class="field-error pb-4">
                                {{ errors.title[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="text-left mb-3">
                        <b-form-group :label="$t('addUpdateTask.descriptionLabel')" class="text-left mb-0">
                            <vue-editor class="job-markdown-editor" v-model="recordPayload.description"
                                :editor-toolbar="customToolbar" />
                            <p v-if="errors && errors.description" class="field-error mt-2">
                                {{ errors.description[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    </b-row>
                    <b-row class="px-4" :class="recordPayload.record_choice !== 'Select' ? 'mb-7rem' : 'mb-0'">
                    <b-col md="6" sm="12" class="mt-3" v-if="!allowEditTask">
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('addUpdateTask.modelLabel') }}</label>
                            <b-form-select @change="getModelValue" class="f-12" :options="modelOptionsList" v-model="recordPayload.model">
                            </b-form-select>
                            <p v-if="errors && errors.model" class="field-error">
                                {{ errors.model[0] }}
                            </p>
                        </div>

                    </b-col>
                    <b-col md="6" sm="12" class="mt-3" v-if="!allowEditTask">
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('addUpdateTask.recordsLabel') }}</label>
                            <b-form-select class="f-12"
                                :disabled="recordPayload.model === 'Company' || recordPayload.model === '-'" :options="recordChoiceOptions" v-model="recordPayload.record_choice">
                            </b-form-select>
                            <p v-if="errors && errors.record_choice" class="field-error">
                                {{ errors.record_choice[0] }}
                            </p>
                        </div>

                    </b-col>
                    <b-col sm="12" v-if="recordPayload.record_choice === 'Select'">
                        <div class="text-left">
                            <label class="state">{{ $t('addUpdateTask.tagsLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" multiple v-model="recordPayload.tags" :options="allTags"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @input="setTagsData">
                            </v-select>

                        </div>
                    </b-col>
                    <b-col sm="12" v-if="recordPayload.record_choice === 'Select'">
                        <div class="text-left mt-3">
                            <label class="state">{{ $t('addUpdateTask.recordsLabel') }}</label>
                            <v-select class="bg_white w-100 mh-40px f-12" multiple v-model="availableRecords"
                                :options="modelOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchAssets" @option:deselected="deleteRecord">
                                <span slot="no-options">
                                    {{ $t('addUpdateTask.searchUnitOrName') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.record_ids" class="field-error">
                                {{ errors.record_ids[0] }}
                            </p>
                        </div>
                        <hr class="my-4" />
                    </b-col>
                    <b-col sm="12" v-if="recordPayload.record_choice === 'Select'">
                        <h3 class="f-18 font-weight-bold text-left mb-3">{{ $t('addUpdateTask.recordsCount', { count: availableRecords.length }) }}</h3>
                    </b-col>
                </b-row>
                <div class="recurring-schedule-table mb-7rem" v-if="recordPayload.record_choice === 'Select'">
                    <b-table responsive :fields="translatedFields" :items="items" hover :current-page="currentPage" show-empty>
                        <template #cell(action)="data">
                            <svg @click="deleteTableItem(data.item.id)" class="cursor-pointer" width="19" height="20"
                                viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="d-flex align-items-center justify-content-end">
                    <div class="text-right modal-footer border-0 p-0">
                        <b-button class="mx-0 h-40px w-100px m-0" :class="hasChanged ? 'mr-3' : ''" @click="resetPopup()"
                            variant="secondary">{{ allowEditTask ? $t('addUpdateTask.close') : $t('addUpdateTask.cancel') }}</b-button>
                        <b-button v-if="hasChanged" class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                            @click="addAndUpdateTask()">{{ $t('addUpdateTask.save') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex"
import * as moment from "moment-timezone";
import { checkValueExists, pickerDate } from "@/services/helper";
import "vue-select/dist/vue-select.css";
import { VueEditor } from "vue2-editor";
export default {
    name: "AddAndUpdateTask",
    components: {
        DatePicker,
        vSelect,
        VueEditor
    },
    props: {
        showRecord: {
            type: [Boolean],
            default: false,
        },
        taskData: {
            type: [Object],
            default: null,
        }

    },
    data() {
        return {
            checkValueExists,
            nameOptions: [],
            availableRecords: [],
            currentPage: 1,
            customToolbar: [
                // Text style
                ["bold", "italic", "underline", "strike"],

                // Headers and fonts
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],

                // Lists
                [{ list: "ordered" }, { list: "bullet" }],

                // Alignment
                [{ align: [] }],

                // Colors
                [{ color: [] }, { background: [] }],

                // Links, images, etc.
                ["link", "image"],

                // Clear formatting
                ["clean"]
            ],
            items: [],
            allowEditTask: false,
            defaultData: {
                due_date: '',
                task: '',
                assigned_to: '',
                description: '',
                model: '-',
                record_choice: 'All',
                tags: [],
                availableRecords: []
            },
            recordPayload: {
                due_date: '',
                assigned_to: '',
                title: '',
                description: '',
                model: '-',
                record_choice: 'All',
                tags: []
            },
            errors: {},
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            modelOptions: []
        };
    },
    computed: {
        ...mapGetters(['userCompany', 'tags', 'allTeamMembers']),
        translatedFields() {
            return [
                { label: this.$t('addUpdateTask.columnRecord'), key: "record", sortable: true, thClass: 'font-table-weight-bold' },
                { label: this.$t('addUpdateTask.columnAction'), key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        modelOptionsList() {
            return [
                { value: '-', text: '-' },
                { value: 'Driver', text: this.$t('addUpdateTask.modelDriver') },
                { value: 'Vehicle', text: this.$t('addUpdateTask.modelVehicle') },
                { value: 'Trailer', text: this.$t('addUpdateTask.modelTrailer') },
                { value: 'Company', text: this.$t('addUpdateTask.modelCompany') },
            ];
        },
        recordChoiceOptions() {
            return [
                { value: 'All', text: this.$t('addUpdateTask.recordsAll') },
                { value: 'Select', text: this.$t('addUpdateTask.recordsSelect') },
            ];
        },
        hasChanged() {
            const currentDueDate = this.recordPayload.due_date ? moment(this.recordPayload.due_date).format('YYYY-MM-DD') : '';
            const defaultDueDate = this.defaultData.due_date ? moment(this.defaultData.due_date).format('YYYY-MM-DD') : '';
            return currentDueDate !== defaultDueDate ||
                this.defaultData?.availableRecords?.toString() !== this.availableRecords.toString() ||
                this.defaultData.tags.toString() !== this.recordPayload.tags.toString() ||
                Object.keys(this.recordPayload).filter(field => {
                    if (field !== 'tags' && field !== 'due_date') {
                        if (!this.recordPayload[field] && !this.defaultData[field]) return false
                        return this.checkValueExists(this.recordPayload[field]) != this.checkValueExists(this.defaultData[field])
                    } return false
                }).length > 0
        },
        taskTitle() {
            return this.allowEditTask ? this.taskData?.record : this.$t('addUpdateTask.addTitle')
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        },

    },
    watch: {
        availableRecords: {
            handler() {
                if (this.availableRecords.length) {
                    const data = this.availableRecords.map(id => {
                        const foundItem = this.modelOptions.find(item => item.id === id);
                        if (foundItem) {
                            return foundItem
                        }
                    });
                    data.map((item) => {
                        if (this.items.filter((data) => data.id === item.id).length === 0) {
                            this.items.push({
                                record: item.label,
                                id: item.id
                            })
                        }
                    })
                } else this.items = []
            },
            deep: true
        },
        showRecord: {
            handler(newVal) {
                if (newVal) {
                    this.getAllTags(this.userCompany)
                }
            },
            immediate: true
        },
        taskData: {
            handler(newVal) {
                if (newVal) {
                    this.allowEditTask = true
                    this.recordPayload.due_date =  pickerDate(newVal.due_date)
                    this.recordPayload.description = newVal.description;
                    this.recordPayload.title = newVal.title;
                    if(newVal.assigned_to){
                    this.recordPayload.assigned_to = newVal.assigned_to.id;
                    this.nameOptions = [{
                        id: newVal.assigned_to.id,
                        label: newVal.assigned_to.name
                    }]
                }
                    this.defaultData = JSON.parse(JSON.stringify({
                        ...this.recordPayload,
                        due_date: this.recordPayload.due_date ? moment(this.recordPayload.due_date).format('YYYY-MM-DD') : '',
                        tags: [],
                        availableRecords: []
                    }))
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ...mapActions(['getFilteredDrivers', 'getAllDrivers', 'getAllTeamMembers', 'getAllTags', 'getAllEquipments', 'setLoader', 'setNotification', 'addTaskData', 'updateTaskData']),
        async setTagsData() {
            if (this.recordPayload.tags.length) {
                let options = []
                this.modelOptions = [...this.modelOptions.filter(item => this.availableRecords.includes(item.id))]
                const tags = this.recordPayload.tags.map(id => {
                    const foundItem = this.tags.find(item => item.id === id);
                    if (foundItem) {
                        return foundItem.add_tag
                    }
                });
                let url = ""
                if (this.recordPayload.model === 'Driver') url = `tags=${tags.toString()}&status=True&sort_field=name&sort_order=asc&page=1&page_size=25`
                else url = `tags=${tags.toString()}&status=Active,Assigned&sort_field=unit_no&sort_order=asc&page=1&page_size=25&type=${this.recordPayload.model}`
                try {
                    this.setLoader(true)
                    if (this.recordPayload.model === 'Driver') {
                        const driverRecords = await this.getAllDrivers(url);
                        driverRecords.records.map((item) => {
                            options.push({
                                id: `${item.id}`,
                                label: item.name
                            });
                        });
                    }
                    else {
                        const equipmentRecords = await this.getAllEquipments(url);
                        equipmentRecords.records.map((item) => {
                            options.push({
                                id: `${item.id}`,
                                label: item.unit_no
                            });
                        });
                    }
                    this.modelOptions = [...options, ...this.modelOptions]
                    this.modelOptions = [...new Map(this.modelOptions.map(item => [item['id'], item])).values()]
                    this.availableRecords = Array.from(
                        new Set([
                            ...this.availableRecords,
                            ...this.modelOptions.map(item => item.id)
                        ])
                    )
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                }
            }
        },
        getModelValue(modelValue) {
            this.availableRecords = []
            this.items = []
            this.recordPayload.tags = []
            if (modelValue === 'Company' || modelValue === '-') {
                this.recordPayload.record_choice = 'All'
            }
        },
        resetPopup() {
            this.recordPayload = {
                due_date: '',
                assigned_to: '',
                title: '',
                description: '',
                model: '-',
                record_choice: 'All',
                tags: []
            }
            this.errors = {}
            this.allowEditTask = false
            this.items = []
            this.modelOptions = [],
                this.availableRecords = [],
                this.$emit('close');
        },
        deleteRecord(option) {
            this.items = this.items.filter((item) => item.id !== option.id)
        },
        deleteTableItem(id) {
            this.availableRecords = this.availableRecords.filter((item) => item !== id)
            this.items = this.items.filter((item) => item.id !== id)
        },
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                let url = ""
                if (this.recordPayload.model === 'Driver') url = `name=${searchText}&&status=True&sort_field=name&sort_order=asc&page=1&page_size=25`
                else url = `unit_no=${searchText}&status=Active,Assigned&sort_field=unit_no&sort_order=asc&page=1&page_size=25&type=${this.recordPayload.model}`
                try {
                    if (this.recordPayload.model === 'Driver') {
                        const driverRecords = await this.getAllDrivers(url);
                        driverRecords.records.map((item) => {
                            options.push({
                                id: `${item.id}`,
                                label: item.name
                            });
                        });
                    }
                    else {
                        const equipmentRecords = await this.getAllEquipments(url);
                        equipmentRecords.records.map((item) => {
                            options.push({
                                id: `${item.id}`,
                                label: item.unit_no
                            });
                        });
                    }
                    this.modelOptions = [...options, ...this.modelOptions]
                    this.modelOptions = [...new Map(this.modelOptions.map(item => [item['id'], item])).values()]
                }
                catch (e) {
                    console.log(e)
                }
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (key === 'record_ids' && this.recordPayload.record_choice === 'Select') {
                    if (value.length === 0) {
                        nullKeys.push(key);
                    }
                }
                else {
                    if (!value) {
                        nullKeys.push(key);
                    }
                }
            }
            return nullKeys;
        },
        async addAndUpdateTask() {
            try {
                const nullKeys = this.checkNullValues({
                    description: this.recordPayload.description,
                    due_date: this.recordPayload.due_date,
                    title: this.recordPayload.title,
                    ...!this.allowEditTask ? { model: this.recordPayload.model } : {},
                    ...!this.allowEditTask && this.recordPayload.record_choice === 'Select' ? { record_ids: this.availableRecords } : {},
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)

                    if (this.allowEditTask) {
                        const payload = {
                            due_date: this.recordPayload.due_date ? moment(this.recordPayload.due_date).format('YYYY-MM-DD') : null,
                            assigned_to: this.recordPayload.assigned_to,
                            description: this.recordPayload.description,
                            title: this.recordPayload.title
                        }
                        payload.id = this.taskData.id
                        await this.updateTaskData({ taskId: this.taskData.id, payload })
                    }
                    else {
                        const payload = {
                            due_date: this.recordPayload.due_date ? moment(this.recordPayload.due_date).format('YYYY-MM-DD') : null,
                            add_date: moment().format('YYYY-MM-DD'),
                            status: 'Open',
                            assigned_to: this.recordPayload.assigned_to,
                            description: this.recordPayload.description,
                            model: this.recordPayload.model,
                            record_choice: this.recordPayload.record_choice,
                            record_ids: this.recordPayload.record_choice === 'Select' ? this.availableRecords : [],
                            title: this.recordPayload.title
                        }
                        await this.addTaskData(payload)
                    }
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.allowEditTask ? this.$t('addUpdateTask.taskUpdated') : this.$t('addUpdateTask.taskAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.$emit('taskUpdated')
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('addUpdateTask.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
};
</script>
<style>
.mh-40px .vs__dropdown-toggle {
    min-height: 40px !important;
}
</style>